import React, { useEffect, useRef, useState } from "react";
const GOOGLE_MAPS_API_KEY = "AIzaSyDaxUrP_VnvtKA94nIyiQgaT1x4EDUCmU4";


export default function PolygonMap() {
    const mapContainerRef = useRef(null);
    const mapInstanceRef = useRef(null);

    const polygonRef = useRef(null);
    const temporaryPolygonRef = useRef(null);

    const drawingRef = useRef(false);

    const [drawing, setDrawing] = useState(false);
    const [points, setPoints] = useState([]);
    const [coordinates, setCoordinates] = useState([]);
    const [nombre, setNombre] = useState("");
    const [saving, setSaving] = useState(false);

    const API_URL = window.path_service_website+"/api/zonas";

    console.log(window.path_service_website,API_URL)


    useEffect(() => {
        loadGoogleMaps();

        return () => {
            deletePolygonFromMap();
        };
    }, []);

    useEffect(() => {
        drawingRef.current = drawing;
    }, [drawing]);

    const loadGoogleMaps = () => {
        if (window.google?.maps) {
            initMap();
            return;
        }

        const existingScript = document.getElementById(
            "google-maps-script"
        );

        if (existingScript) {
            existingScript.addEventListener("load", initMap, {
                once: true
            });

            return;
        }

        const script = document.createElement("script");

        script.id = "google-maps-script";
        script.src =
            `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}`;
        script.async = true;
        script.defer = true;
        script.onload = initMap;

        document.head.appendChild(script);
    };

    const initMap = () => {
        if (!mapContainerRef.current || mapInstanceRef.current) {
            return;
        }

        const map = new window.google.maps.Map(
            mapContainerRef.current,
            {
                center: {
                    lat: -12.046374,
                    lng: -77.042793
                },
                zoom: 14,
                mapTypeControl: true,
                streetViewControl: false
            }
        );

        mapInstanceRef.current = map;

        map.addListener("click", event => {
            if (!drawingRef.current) {
                return;
            }

            const newPoint = {
                lat: event.latLng.lat(),
                lng: event.latLng.lng()
            };

            addPoint(newPoint);
        });
    };

    const addPoint = newPoint => {
        setPoints(previousPoints => {
            const updatedPoints = [
                ...previousPoints,
                newPoint
            ];

            drawTemporaryPolygon(updatedPoints);

            return updatedPoints;
        });
    };

    const drawTemporaryPolygon = polygonPoints => {
        if (!mapInstanceRef.current) {
            return;
        }

        if (temporaryPolygonRef.current) {
            temporaryPolygonRef.current.setMap(null);
        }

        temporaryPolygonRef.current =
            new window.google.maps.Polygon({
                paths: polygonPoints,
                strokeColor: "#2563EB",
                strokeOpacity: 1,
                strokeWeight: 2,
                fillColor: "#2563EB",
                fillOpacity: 0.25,
                clickable: false,
                editable: false,
                map: mapInstanceRef.current
            });
    };

    const startDrawing = () => {
        deletePolygonFromMap();

        setPoints([]);
        setCoordinates([]);

        setDrawing(true);
        drawingRef.current = true;
    };

    const finishDrawing = () => {
        if (points.length < 3) {
            alert("Debes seleccionar como mínimo 3 puntos.");
            return;
        }

        if (!mapInstanceRef.current) {
            alert("El mapa todavía no está disponible.");
            return;
        }

        setDrawing(false);
        drawingRef.current = false;

        if (temporaryPolygonRef.current) {
            temporaryPolygonRef.current.setMap(null);
            temporaryPolygonRef.current = null;
        }

        const polygon = new window.google.maps.Polygon({
            paths: points,

            editable: true,
            draggable: false,

            strokeColor: "#2563EB",
            strokeOpacity: 1,
            strokeWeight: 2,

            fillColor: "#2563EB",
            fillOpacity: 0.25,

            map: mapInstanceRef.current
        });

        polygonRef.current = polygon;

        configurePolygonListeners(polygon);
        updateCoordinates(polygon);
    };

    const configurePolygonListeners = polygon => {
        const path = polygon.getPath();

        path.addListener("set_at", () => {
            updateCoordinates(polygon);
        });

        path.addListener("insert_at", () => {
            updateCoordinates(polygon);
        });

        path.addListener("remove_at", () => {
            updateCoordinates(polygon);
        });
    };

    const updateCoordinates = polygon => {
        const path = polygon.getPath();
        const updatedCoordinates = [];

        for (let index = 0; index < path.getLength(); index++) {
            const position = path.getAt(index);

            updatedCoordinates.push({
                lat: position.lat(),
                lng: position.lng()
            });
        }

        setCoordinates(updatedCoordinates);

        console.log(
            "Coordenadas actuales:",
            updatedCoordinates
        );
    };

    const guardarPolygon = async () => {
        if (!polygonRef.current) {
            alert("Primero debes finalizar el polígono.");
            return;
        }

        /*
         * Se vuelven a leer las coordenadas directamente
         * del polígono para guardar la última edición.
         */
        const path = polygonRef.current.getPath();
        const currentCoordinates = [];

        for (let index = 0; index < path.getLength(); index++) {
            const position = path.getAt(index);

            currentCoordinates.push({
                lat: position.lat(),
                lng: position.lng()
            });
        }

        if (currentCoordinates.length < 3) {
            alert("El polígono debe tener al menos 3 puntos.");
            return;
        }

        if (!nombre.trim()) {
            alert("Ingresa un nombre para el polígono.");
            return;
        }

        try {
            setSaving(true);

            const response = await fetch(API_URL, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json"
                },
                body: JSON.stringify({
                    nombre: nombre.trim(),
                    coordinates: currentCoordinates
                })
            });

            const responseText = await response.text();

            let result;

            try {
                result = JSON.parse(responseText);
            } catch {
                throw new Error(
                    `El servidor no devolvió JSON válido: ${responseText}`
                );
            }

            if (!response.ok || result.status === false) {
                throw new Error(
                    result.message ||
                    "No se pudo guardar el polígono."
                );
            }

            setCoordinates(currentCoordinates);

            alert(
                `Polígono guardado correctamente. ID: ${result.id}`
            );

            console.log("Respuesta del backend:", result);
        } catch (error) {
            console.error(error);

            alert(
                error.message ||
                "Ocurrió un error al guardar el polígono."
            );
        } finally {
            setSaving(false);
        }
    };

    const deletePolygonFromMap = () => {
        if (polygonRef.current) {
            polygonRef.current.setMap(null);
            polygonRef.current = null;
        }

        if (temporaryPolygonRef.current) {
            temporaryPolygonRef.current.setMap(null);
            temporaryPolygonRef.current = null;
        }

        setPoints([]);
        setCoordinates([]);
        setDrawing(false);

        drawingRef.current = false;
    };

    const deletePolygon = () => {
        deletePolygonFromMap();
    };

    return (
        <div>
            <div
                style={{
                    marginBottom: 15,
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 10,
                    alignItems: "center"
                }}
            >
                <input
                    type="text"
                    value={nombre}
                    onChange={event =>
                        setNombre(event.target.value)
                    }
                    placeholder="Nombre de la zona"
                    style={{
                        minWidth: 220,
                        padding: "10px 12px"
                    }}
                />

                <button
                    type="button"
                    onClick={startDrawing}
                    disabled={drawing || saving}
                >
                    Dibujar polígono
                </button>

                <button
                    type="button"
                    onClick={finishDrawing}
                    disabled={!drawing || saving}
                >
                    Finalizar polígono
                </button>

                <button
                    type="button"
                    onClick={guardarPolygon}
                    disabled={
                        !polygonRef.current ||
                        coordinates.length < 3 ||
                        saving
                    }
                >
                    {saving
                        ? "Guardando..."
                        : "Guardar polígono"}
                </button>

                <button
                    type="button"
                    onClick={deletePolygon}
                    disabled={saving}
                >
                    Eliminar polígono
                </button>
            </div>

            {drawing && (
                <p>
                    Haz clic en el mapa para agregar puntos y luego
                    presiona “Finalizar polígono”.
                </p>
            )}

            <div
                ref={mapContainerRef}
                style={{
                    width: "100%",
                    height: "600px",
                    border: "1px solid #ddd",
                    borderRadius: 6
                }}
            />

            <div style={{ marginTop: 20 }}>
                <h3>Coordenadas actuales</h3>

                <pre
                    style={{
                        padding: 15,
                        maxHeight: 300,
                        overflow: "auto",
                        backgroundColor: "#f4f4f4",
                        borderRadius: 6
                    }}
                >
                    {JSON.stringify(coordinates, null, 2)}
                </pre>
            </div>
        </div>
    );
}